var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{staticClass:"d-block ma-auto font--button rounded-pill hero-cta accent--text",attrs:{"depressed":"","medium":"","color":"white"},on:{"click":_setup.toggleReferral}},[_vm._v("\n  "+_vm._s(_vm.$t('components.myTheater.referUsers'))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }